import { render } from "./CollectionCardActions.vue?vue&type=template&id=45b52e2e"
import script from "./CollectionCardActions.vue?vue&type=script&lang=js"
export * from "./CollectionCardActions.vue?vue&type=script&lang=js"

import "./CollectionCardActions.vue?vue&type=style&index=0&id=45b52e2e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__